import React from "react";
import Select from "react-select";

class SelectExtended extends React.PureComponent {
    render() {
        return (
            <Select {...this.props} />
        );
    }
}

export default SelectExtended;
